import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TimeRange, TIME_RANGE_LABELS } from "@/types/documento";
import { cn } from "@/lib/class-control";

interface TimeRangeFilterProps {
  value: TimeRange;
  onChange: (value: TimeRange) => void;
  className?: string;
}

/**
 * TimeRangeFilter Component
 *
 * Dropdown filter for selecting time range for document filtering.
 * Uses existing Select component from ui/select.tsx.
 *
 * @param value - Current selected time range
 * @param onChange - Callback when selection changes
 * @param className - Optional additional CSS classes
 */
export function TimeRangeFilter({
  value,
  onChange,
  className,
}: TimeRangeFilterProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        className={cn(
          "border border-[#5D5D5D] rounded-[10px] px-[20px] py-[10px] h-[50px] w-[256px]",
          "bg-transparent text-[#F6F6F6] text-[16px] font-['Plus_Jakarta_Sans']",
          "hover:bg-[#15203C]/50 transition-colors",
          className
        )}
      >
        <SelectValue placeholder="Selecione o período" />
      </SelectTrigger>
      <SelectContent>
        {(Object.keys(TIME_RANGE_LABELS) as TimeRange[]).map((range) => (
          <SelectItem key={range} value={range}>
            {TIME_RANGE_LABELS[range]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
